// extracted by mini-css-extract-plugin
export default {"column":"CWHE8z","divider":"DwLZxt"};